/* eslint-disable @typescript-eslint/no-explicit-any */

import { parse } from "qs";

// TODO : add on ScrollSectionItem with new {} param and test
export const getHeightStickyOnTop = () => {
  const elementsStickyOnTop: HTMLDivElement[] | [] = Array.from(
    document.querySelectorAll(".stickyOnTop"),
  );
  return elementsStickyOnTop.reduce((acc, item) => {
    return acc + item.offsetHeight;
  }, 0);
};

export const mergeUniqueBy = (a: any[], b: any[], p: string) =>
  a
    .filter(
      (aa: { [x: string]: any }) =>
        !b.find(
          (bb: { [x: string]: any }) =>
            typeof aa[p] !== "undefined" &&
            typeof bb[p] !== "undefined" &&
            aa[p] === bb[p],
        ),
    )
    .concat(b);

export const uniqBy = (arr: any[], predicate: any) => {
  const cb =
    typeof predicate === "function"
      ? predicate
      : (o: { [x: string]: any }) => o[predicate];

  return [
    ...arr
      .reduce((map, item) => {
        const key = item === null || item === undefined ? item : cb(item);

        if (!map.has(key)) map.set(key, item);

        return map;
      }, new Map())
      .values(),
  ];
};

export const getDeepVal = (obj: any, path: string): any => {
  if (typeof obj === "undefined" || obj === null) return false;

  const splitPath: string[] = path.split(/[.[\]"']{1,2}/);

  for (let i = 0, l = splitPath.length; i < l; i += 1) {
    if (splitPath[i] !== "") {
      obj = obj[splitPath[i]];
      if (typeof obj === "undefined" || obj === null) return false;
    }
  }

  return obj;
};

export const stringIsNumber = (
  value: string,
  minLength = 0,
  maxLength = 100,
) => {
  const numberRegex = RegExp(`^[0-9]{${minLength},${maxLength}}$`);
  return numberRegex.test(value);
};

export const isObject = (prop: unknown) =>
  Object.prototype.toString.call(prop) === "[object Object]";

export const isValidString = (prop: unknown) =>
  typeof prop === "string" && prop.length > 0;

export const getParams = (key: string) => {
  const params = parse(window.location.search, {
    ignoreQueryPrefix: true,
  })[key] as string;
  return params;
};

export const checkForRegex = (
  regexToFind: string,
  searchInField: string,
  returnIfFound: string | number | boolean = true,
  regexFlag: "i" | "g" | "m" | "gi" | "mi" = "g",
) => {
  const regex = new RegExp(regexToFind, regexFlag);
  if (searchInField && regex.test(searchInField)) {
    return returnIfFound;
  }
  return false;
};

export const isProdDomain = () => {
  let url = "";

  if (typeof document !== "undefined") {
    url = window.location.href;
  }

  const domainRegex = /^(https:\/\/)(?:[^.]+\.)?telepass\.com(\/.*)?$/;
  return domainRegex.test(url);
};

export async function asyncForEach(
  array: any,
  callback: (arg0: any, arg1: number, arg2: any) => any,
) {
  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < array.length; index++) {
    // eslint-disable-next-line no-await-in-loop
    await callback(array[index], index, array);
  }
}
